/**
 * @generated SignedSource<<20283dec776d680c298918bcfb2f091c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShallowAnswerPreview_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewString_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewText_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewRichText_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewFile_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewCheckBoxes_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewBudgetDispatcher_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewSortableList_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewMatrix_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewThemes_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewEvents_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewEmailWithConsents_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewOralInterview_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewPresentationSeparator_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewPresentationTitle_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewPresentationTextZone_answer"
    }
  ],
  "type": "AnswerBase",
  "abstractKey": "__isAnswerBase"
};

node.hash = "e3d6648d30a90ba4037b3caf89535437";

module.exports = node;
